import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DotsMenuIconSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_669_37616)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 12C7 13.6545 5.6545 15 4 15C2.3455 15 1 13.6545 1 12C1 10.3455 2.3455 9 4 9C5.6545 9 7 10.3455 7 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 12C15 13.6545 13.6545 15 12 15C10.3455 15 9 13.6545 9 12C9 10.3455 10.3455 9 12 9C13.6545 9 15 10.3455 15 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23 12C23 13.6545 21.6545 15 20 15C18.3455 15 17 13.6545 17 12C17 10.3455 18.3455 9 20 9C21.6545 9 23 10.3455 23 12Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_37616'>
        <rect width='24' height='24' fill='white' transform='translate(0 24) rotate(-90)' />
      </clipPath>
    </defs>
  </svg>
);

export const DotsMenuIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DotsMenuIconSvg} {...props} />
);
